
export const PlanType = {
  FREE: "app.plan.Free"
};
